import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "dashboard-header" }
const _hoisted_3 = { class: "period-selector" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_6 = { class: "summary-cards" }
const _hoisted_7 = { class: "summary-card" }
const _hoisted_8 = { class: "card-value" }
const _hoisted_9 = { class: "summary-card" }
const _hoisted_10 = { class: "card-value" }
const _hoisted_11 = { class: "summary-card" }
const _hoisted_12 = { class: "card-value" }
const _hoisted_13 = { class: "charts-row" }
const _hoisted_14 = { class: "chart-card chart-wide" }
const _hoisted_15 = { class: "chart-container" }
const _hoisted_16 = {
  key: 1,
  class: "no-data"
}
const _hoisted_17 = { class: "charts-row" }
const _hoisted_18 = { class: "chart-card" }
const _hoisted_19 = { class: "chart-container" }
const _hoisted_20 = {
  key: 1,
  class: "no-data"
}
const _hoisted_21 = { class: "chart-card" }
const _hoisted_22 = {
  key: 0,
  class: "events-table"
}
const _hoisted_23 = { class: "events-name" }
const _hoisted_24 = { class: "events-count" }
const _hoisted_25 = {
  key: 1,
  class: "no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Line = _resolveComponent("Line")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_AdminLayout = _resolveComponent("AdminLayout")!

  return (_openBlock(), _createBlock(_component_AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Аналитика", -1)),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (p) => {
              return (_openBlock(), _createElementBlock("button", {
                key: p.value,
                class: _normalizeClass(["period-btn", { active: _ctx.period === p.value }]),
                onClick: ($event: any) => (_ctx.changePeriod(p.value))
              }, _toDisplayString(p.label), 11, _hoisted_4))
            }), 128))
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Загрузка..."))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.overview.unique_visitors), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-label" }, "Уникальных посетителей", -1))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.overview.total_views), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-label" }, "Просмотров страниц", -1))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.overview.total_events), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-label" }, "Действий (клики)", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Посетители по дням", -1)),
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.visitorsChartData)
                      ? (_openBlock(), _createBlock(_component_Line, {
                          key: 0,
                          data: _ctx.visitorsChartData,
                          options: _ctx.lineOptions
                        }, null, 8, ["data", "options"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, "Нет данных"))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Популярные страницы", -1)),
                  _createElementVNode("div", _hoisted_19, [
                    (_ctx.pagesChartData)
                      ? (_openBlock(), _createBlock(_component_Bar, {
                          key: 0,
                          data: _ctx.pagesChartData,
                          options: _ctx.barOptions
                        }, null, 8, ["data", "options"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, "Нет данных"))
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Действия пользователей", -1)),
                  (_ctx.events.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "events-row events-header" }, [
                          _createElementVNode("span", { class: "events-name" }, "Событие"),
                          _createElementVNode("span", { class: "events-count" }, "Кол-во")
                        ], -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (evt) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: evt.name,
                            class: "events-row"
                          }, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.eventLabel(evt.name)), 1),
                            _createElementVNode("span", _hoisted_24, _toDisplayString(evt.count), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, "Нет данных"))
                ])
              ])
            ], 64))
      ])
    ]),
    _: 1
  }))
}